import React from "react";
import styles from "./FamilyProfileOverlaySheet.module.css"; // You can move or reuse the CSS
import childAvatar from "../../../assets/childProfile.svg";
import { FamilySummary } from "../../../gql/types";

type FamilyMemberListProps = {
    family: FamilySummary;
};

const FamilyMemberList: React.FC<FamilyMemberListProps> = ({ family }) => {
    const renderMemberRow = (
        id: string,
        name: string,
        role: "Parent" | "Child",
        avatar?: string,
        initial?: string
    ) => (
        <div key={id} className={styles.memberRow}>
            <div className={styles.memberRowLeft}>
                {avatar ? (
                    <div className={styles.initialAvatar}>
                        <img src={avatar} className={styles.avatar} />
                    </div>
                ) : (
                    <div className={styles.initialAvatar}>{initial}</div>
                )}
                <span className={styles.memberName}>{name}</span>
            </div>
            <div className={styles.memberRowRight}>{role}</div>
        </div>
    );

    return (
        <>
            {family.parents?.map((parent) => {
                const name = `${parent.firstName ?? ""} ${parent.lastName ?? ""}`.trim();
                const initial = name[0] ?? "P";
                return renderMemberRow(parent.id, name, "Parent", undefined, initial);
            })}
            {family.children?.map((child, index) => {
                const name = child.name;
                const initial = name[0] ?? "C";
                return renderMemberRow(
                    `${name}-${index}`,
                    name,
                    "Child",
                    childAvatar,
                    initial
                );
            })}
        </>
    );
};

export default FamilyMemberList;
